<template>
  <div>
    <div class="wrap">
      <card :data="list" type="collect" class="card border-bottom" v-if="loaded"></card>
    </div>
    <div class="nodata" v-if="loaded&&list.length === 0">
      <img src="~@/common/image/no-course.png" alt="">
      <p>您还没有收藏课程哦</p>
    </div>
    <loading v-show="!loaded"></loading>
  </div>
</template>

<script>
import Card from './card'
import Loading from 'components/base/loading/loading.vue'
import {getUserCourse} from '@/api/user-center.js'
import {RES_OK} from '@/api/config'
export default {
  data() {
    return {
      loaded: false,
      list: []
    }
  },
  components: {
    Loading,
    Card
  },
  created() {
    // 所有课程
    getUserCourse(5).then((res) => {
      let data = res.data
      if (data && data.code === RES_OK && data.data) {
        console.log(this.list)
        this.list = data.data
        this.loaded = true
      }
    })
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .wrap
    padding-left size(30)
    padding-right size(30)
    padding-bottom size(120)
  .nodata
    width size(300)
    margin size(250) auto 0
    p
      color #999
      text-align center
      font-size size(30)
      margin-top size(58)
    img
      display block
      width 100%
</style>


// WEBPACK FOOTER //
// src/components/mycourse/collection.vue